import styled from "styled-components";

export const Container = styled.div<{ $snapDisabled?: boolean }>`
  // position: fixed;
  inset: 0;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  top: 0;
  overflow-y: auto;
  scroll-snap-type: ${props => (props.$snapDisabled ? 'none' : 'y mandatory')};
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  background: #000;
  z-index: 99999;  
  // Add a reserved top space for header/title/VoteAndPower
  --top-ui-space: 100px;

  @media (max-width: 480px) {
    --top-ui-space: 0px;
  }
`;


export const Loader = styled.div`
  text-align: center;
  color: #7a7a8a;
  padding: 16px 0;
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-12);
`;

// Centered overlay loader for vote processing state
export const VoteLoaderOverlay = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.41);
`;

export const VoteLoaderText = styled.div`
  color: #ffffff;
  font-family: var(--font-family-poppins);
  font-size: clamp(16px, 4vw, 24px);
  font-weight: 700;
`;

export const ReelCard = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  scroll-snap-align: start;
  scroll-snap-stop: always;
  border-radius: 0;
  overflow: hidden;
  background: #000;
  border: none;
`;

export const HeroImage = styled.img`
  position: relative;
  z-index: 1;
  display: block;
  margin: 0 auto;
  height: 100%;
  width: auto;
  max-width: 100%;
  max-width: min(100%, 800px);
  object-fit: contain;
  background: transparent;
  // Push media down to create top space
  // margin-top: var(--top-ui-space);
  // max-height: calc(85% - var(--top-ui-space));
`;

export const HeroVideo = styled.video`
  position: relative;
  z-index: 1;
  display: block;
  margin: 0 auto;
  height: 100%;
  width: auto;
  max-width: 100%;
  max-width: min(100%, 800px);
  object-fit: contain;
  background: transparent;
  // Push media down to create top space
  margin-top: var(--top-ui-space);
  max-height: calc(100% - var(--top-ui-space));
`;

export const HeroBackdrop = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: blur(24px) brightness(0.6);
  transform: scale(1.1);
  z-index: 0;
`;

export const Overlay = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 2;
`;

// Product Tag Component
export const ProductTag = styled.a`
  position: absolute;
  top: clamp(100px, 15vh, 180px);
  right: clamp(16px, 3vw, 24px);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 10px;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  pointer-events: auto;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  max-width: 120px;
  z-index: 10;  
  border-color: rgba(155, 77, 255, 0.5);    
  box-shadow: 0 6px 16px rgba(155, 77, 255, 0.3);

  &:hover {
    background: rgba(0, 0, 0, 0.75);
    border-color: rgba(155, 77, 255, 0.5);
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(155, 77, 255, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 480px) {
    top: clamp(90px, 14vh, 160px);
    right: clamp(12px, 2.5vw, 16px);
    padding: 8px;
    max-width: 100px;
    gap: 6px;
  }
`;

export const ProductImageWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProductImage = styled.img`
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 8px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.1);

  @media (max-width: 480px) {
    width: 60px;
    height: 60px;
  }
`;

export const ProductLinkIcon = styled.div`
  position: absolute;
  top: -4px;
  right: -4px;
  width: 24px;
  height: 24px;
  background: rgba(155, 77, 255, 0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
  transition: all 0.3s ease;

  svg {
    width: 12px;
    height: 12px;
    color: #ffffff;
  }

  ${ProductTag}:hover & {
    background: rgba(155, 77, 255, 1);
    transform: scale(1.1);
    box-shadow: 0 3px 12px rgba(155, 77, 255, 0.6);
  }

  @media (max-width: 480px) {
    width: 20px;
    height: 20px;
    
    svg {
      width: 10px;
      height: 10px;
    }
  }
`;

export const ProductName = styled.span`
  color: #ffffff;
  font-family: var(--font-family-poppins);
  font-size: clamp(11px, 2.5vw, 13px);
  font-weight: 600;
  text-align: center;
  line-height: 1.3;
  word-break: break-word;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
  max-width: 100%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const BottomGradient = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 35vh;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0,0,0,0.6) 40%, rgba(0,0,0,0.9) 100%);
  pointer-events: none;
  z-index: 1;
`;

export const BottomHUD = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: calc(50px + env(safe-area-inset-bottom));
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 0 16px;
  pointer-events: auto;
  z-index: 3;
`;

export const TitleTop = styled.div`
  position: absolute;    
  width: 92%;
  max-width: 720px;
  color: #ffffff;
  text-align: center;
  font-family: var(--font-family-poppins);
  font-size: clamp(16px, 4vw, 28px);
  font-weight: 700;
  line-height: 1.25;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.55);
  z-index: 3;  
`;

export const BottomVoteBar = styled.div`
  position: absolute;
  bottom: calc(${window.innerWidth > 767 ? "40px" : "30px"} + env(safe-area-inset-bottom));
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: clamp(16px, 5vw, 24px);
  pointer-events: auto;
  z-index: 3;
  width: 100%;
  width: 100%;
  max-width: 800px;
  flex-direction: column;
`;

export const CircleButton = styled.button<{ $compactText?: boolean; $isVoted?: boolean }>`
  box-sizing: border-box;
  width: auto;
  height: clamp(48px, 7vh, 64px);
  padding: 12px 20px;
  border-radius: 999px;
  border: 4px solid ${p => p.$isVoted ? 'rgb(0, 210, 255)' : 'rgb(78, 20, 186)'};
  background: ${p => p.$isVoted
    ? 'linear-gradient(180deg, rgba(155, 77, 255, 1) 0%, rgba(106, 41, 221, 1) 100%)'
    : 'linear-gradient(180deg, rgba(11, 1, 29, 1) 0%, rgba(22, 7, 56, 1) 100%)'};
  color: rgb(255, 255, 255);
  font-weight: 700;
  font-family: var(--font-family-poppins);
  font-size: ${p => p.$compactText ? 'clamp(11px, 2.8vw, 14px)' : 'clamp(12px, 2.4vw, 16px)'};
  line-height: 1.2;
  letter-spacing: 0.2px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 clamp(160px, 36vw, 200px);
  max-width: clamp(160px, 36vw, 200px);
  justify-self: center;
  overflow: hidden;
  word-break: break-word;
  white-space: normal;
  text-wrap: balance;
  box-shadow: ${p => p.$isVoted
    ? 'rgba(155, 77, 255, 0.6) 0px 10px 18px, 0 0 20px rgba(0, 210, 255, 0.4)'
    : 'rgba(106, 41, 221, 0.35) 0px 10px 18px'};
  cursor: pointer;
  transition: transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease, background 160ms ease;
  will-change: transform;

  &:hover {
    box-shadow: ${p => p.$isVoted
    ? 'rgba(155, 77, 255, 0.75) 0px 12px 22px, 0 0 25px rgba(0, 210, 255, 0.5)'
    : 'rgba(106, 41, 221, 0.55) 0px 12px 22px'};
    border-color: ${p => p.$isVoted ? 'rgb(138, 180, 248)' : 'rgb(124, 62, 233)'};
    background: ${p => p.$isVoted
    ? 'linear-gradient(180deg, rgba(184, 109, 255, 1) 0%, rgba(124, 62, 233, 1) 100%)'
    : 'linear-gradient(180deg, rgba(18, 4, 46, 1) 0%, rgba(32, 10, 78, 1) 100%)'};
  }

  &:active {
    box-shadow: ${p => p.$isVoted
    ? 'rgba(155, 77, 255, 0.5) 0px 8px 16px, 0 0 15px rgba(0, 210, 255, 0.3)'
    : 'rgba(106, 41, 221, 0.25) 0px 8px 16px'};
  }

  &:focus-visible {
    outline: none;
    box-shadow: ${p => p.$isVoted
    ? '0 0 0 3px rgba(155, 77, 255, 0.6), 0 0 15px rgba(0, 210, 255, 0.5)'
    : '0 0 0 3px rgba(106, 41, 221, 0.6), 0 0 15px rgba(106, 41, 221, 0.5)'};
  }

  @media (max-width: 480px) {
    height: clamp(44px, 8vh, 60px);
    padding: 10px 16px;
    flex: 1 1 100%;
  }
  
  @media (min-width: 1024px) {
    height: 56px;
  }
`;

export const CircleIcon = styled.span`
  font-size: clamp(20px, 6vw, 10px);
  line-height: 1;
  color: #ffffff;  
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const VoteButtonsContainer = styled.div`
  display: flex;
  // flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: clamp(16px, 4vw, 24px);
  margin-bottom: clamp(10px, 6vw, 40px);
  width: 100%;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;  

  @media (max-width: 560px) {
    align-items: center;
    gap: clamp(12px, 6vw, 18px);
  }
`;

export const AfterVoteShowPercentage = styled.div`
 position: absolute;
//  border:1px solid red;
  margin: 0 auto;
  left: 50%;
  transform: translateX(-50%);
  z-index: 90;
  display: flex;
  justify-content:space-around;
  align-items: center;
  gap: 0;
  width: 100%;
  max-width: 550px;  
  bottom:${window.innerWidth < 767 ? "-15px" : "-10px"};
`;

export const ProgressBarContainer = styled.div`
  width: 100%;
  padding: 0 20px;
  margin-bottom: clamp(5px, 2vw, 10px);
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

export const ProgressBarWrapper = styled.div`
  width: 100%;
  height: 20px;
  background-color: #9B7BFF; /* deep track */
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  box-shadow: inset 0 2px 8px rgba(0,0,0,0.6);
`;

export const ProgressBarFill = styled.div<{ $leftPercentage: number }>`
  height: 100%;
  width: ${p => p.$leftPercentage}%;
  background: #4b2bd6;
  border-radius: 10px 0 0 10px;
  transition: width 0.45s cubic-bezier(.22,.9,.33,1);
  position: relative;
  box-shadow: inset 0 -2px 6px rgba(0,0,0,0.35);
`;

export const VoteLabelsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 20px;
  margin-top: 8px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

export const VoteLabel = styled.div`
  color: #fff;
  font-family: var(--font-family-poppins);
  font-size: clamp(14px, 3vw, 18px);
  font-weight: 600;
`;

export const VotePercentage = styled.div`
  color: #fff;
  font-family: var(--font-family-poppins);
  font-size: clamp(16px, 3.5vw, 17px);
  font-weight: 700;
`;

export const VoteSVI = styled.div`
  color: #fff;
  font-family:math;
  font-size: clamp(25px, 3.5vw, 24px);
  font-weight: 700;
`;


// Header css
export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 24px;
  min-height: 100px;
  // background-color: #0B011D;  
  color: white;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 100;  
  @media (max-width: 768px) {
    padding: 12px 16px;
  }
  
  @media (max-width: 480px) {
    padding: 10px 12px;
    min-height: 70px;
  }

  @media (max-width: 375px) {
    padding: 10px 0px;
    min-height: 70px;
  }
`;


export const IconButton = styled.button<{ $active?: boolean; $borderColor?: string }>`
  appearance: none;
  border: none;
  background: ${props => (props.$active ? 'rgba(106, 41, 221, 0.2)' : 'transparent')};
  border-radius: 999px;
  padding: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  cursor: pointer;
  outline: none;
  box-shadow: ${props => (props.$active ? '0 0 0 2px rgba(106, 41, 221, 0.6), 0 0 10px rgba(106, 41, 221, 0.45)' : 'none')};
  transform: ${props => (props.$active ? 'scale(1.05)' : 'none')};
  // border: 2px solid rgb(255, 255, 255);
`;

export const HeaderSetUp = styled.div`
  width: 260px;    
  display: flex;
  justify-content: center;
  position: relative;
  height: 70px;
  margin-top: 10px;
`;

export const NavItem = styled.div`
  font-size: 24px;
  font-weight: 500;
  cursor: pointer;
  font-family: var(--font-family-poppins);
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 0.8;
  }
  
  @media (max-width: 768px) {
    font-size: 18px;
  }
  
  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

export const CounterCircle = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #0B011D;
  border: 4px solid #6A29DD;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: bold;
  font-size: 18px;
  box-shadow: 0 0 15px rgba(106, 41, 221, 0.5);
  transition: transform 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
  }
  
  @media (max-width: 768px) {
    width: 70px;
    height: 70px;
    font-size: 16px;
    border-width: 3px;
  }
  
  @media (max-width: 480px) {
    width: 60px;
    height: 60px;
    font-size: 13px;
    border-width: 3px;
  }
  
  @media (max-width: 360px) {
    width: 50px;
    height: 50px;
    font-size: 14px;
    border-width: 2px;
  }
`;

export const ProfilePic = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #6A29DD;
  transition: transform 0.2s ease;
  
  &:hover {
    transform: scale(1.1);
  }
  
  @media (max-width: 768px) {
    width: 32px;
    height: 32px;
  }
  
  @media (max-width: 480px) {
    width: 28px;
    height: 28px;
  }
  
  @media (max-width: 360px) {
    width: 24px;
    height: 24px;
    border-width: 1px;
  }
`;

// Responsive wrapper for right side content
export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;  
  
  @media (max-width: 480px) {
    gap: 4px;
  }
  
  @media (max-width: 360px) {    
  }
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;  
  
  @media (max-width: 480px) {
    gap: 4px;
  }
  
  @media (max-width: 360px) {
   
  }
`;

// Inner container for max-width content
export const HeaderInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  
  @media (max-width: 360px) {
    position: relative;
  }
`;



// Footer css

export const DivForScroll = styled.div` 
  height:100dvh;
  width:100%;    
  border:1px solid red;
   overflow-y: auto;
`
export const InSideDivScroll = styled.div` 
  height:103dvh;
  width:100%;    
  border:1px solid green;
  color:white;
  display:flex;
  flex-direction:column;
  justify-content: center;
  align-items: center;
`
export const FooterContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  padding: 12px 16px 16px 16px;
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
  background: linear-gradient(180deg, #1a0a35 0%, #0d0520 100%);
  border-top: 1px solid rgba(138, 43, 226, 0.3);
  color: white;
  width: 100%;
  position: fixed;
  bottom: 0;
  z-index: 100;
  box-shadow: 0 -4px 20px rgba(106, 41, 221, 0.3);

  @media (max-width: 768px) {
    padding: 10px 12px 14px 12px;
  }
  
  @media (max-width: 480px) {
    padding: 8px 8px 12px 8px;
  }
`;

export const NavItemFooter = styled.div<{ $isCenter?: boolean; $isActive?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  font-family: var(--font-family-poppins);
  transition: all 0.2s ease;
  color: ${props => props.$isActive ? '#ffffff' : 'rgba(255, 255, 255, 0.5)'};
  min-width: 60px;
  position: relative;
  
  &:hover {
    color: #ffffff;
    transform: translateY(-2px);
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  span {
    margin-top: 4px;
    text-transform: capitalize;
    color: ${props => props.$isActive ? '#ffffff' : 'rgba(255, 255, 255, 0.5)'};
  }
  
  @media (max-width: 480px) {
    font-size: 10px;
    min-width: 50px;
  }
`;

export const ActiveIndicator = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 3px;
  background: linear-gradient(90deg, #9B4DFF 0%, #6A29DD 100%);
  border-radius: 0 0 3px 3px;
  box-shadow: 0 2px 10px rgba(155, 77, 255, 0.8);
  
  @media (max-width: 480px) {
    width: 35px;
    height: 2px;
  }
`;

export const IconWrapper = styled.div<{ $isActive?: boolean }>`
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.$isActive ? '#ffffff' : 'rgba(255, 255, 255, 0.5)'};
  transition: all 0.2s ease;
  filter: ${props => props.$isActive ? 'drop-shadow(0 0 8px rgba(155, 77, 255, 0.8)) drop-shadow(0 0 15px rgba(138, 43, 226, 0.6))' : 'none'};
  
  @media (max-width: 768px) {
    font-size: 20px;
  }
  
  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

export const AddButton = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #9B4DFF 0%, #6A29DD 50%, #5020B0 100%);
  border: 3px solid rgba(155, 77, 255, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 28px;
  box-shadow: 
    0 0 20px rgba(155, 77, 255, 0.6),
    0 0 40px rgba(106, 41, 221, 0.4),
    0 4px 15px rgba(0, 0, 0, 0.3),
    inset 0 2px 4px rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  margin-bottom: 8px;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    inset: -6px;
    border-radius: 50%;
    border: 2px solid rgba(155, 77, 255, 0.4);
    animation: pulse 2s infinite;
  }
  
  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.1);
      opacity: 0.5;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  
  &:hover {
    transform: scale(1.1);
    box-shadow: 
      0 0 30px rgba(155, 77, 255, 0.8),
      0 0 60px rgba(106, 41, 221, 0.5),
      0 6px 20px rgba(0, 0, 0, 0.4);
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  @media (max-width: 768px) {
    width: 52px;
    height: 52px;
    font-size: 24px;
  }
  
  @media (max-width: 480px) {
    width: 48px;
    height: 48px;
    font-size: 22px;
    margin-bottom: 6px;
  }
`;



//  vote left and X power button 

export const Pill = styled.button<{ $bgStart?: string; $bgEnd?: string; $shadow?: string; $disabled?: boolean }>`
  appearance: none;
  min-width: 120px;
  border: 0;
  outline: none;
  cursor: ${(p) => (p.$disabled ? "not-allowed" : "pointer")};
  user-select: none;
  border-radius: 9999px;
  padding: 13px 18px;
  font-family: var(--font-family-poppins);
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.2px;
  color: #fff;
  background: linear-gradient(135deg, ${(p) => p.$bgStart || "#7A3CFF"}, ${(p) => p.$bgEnd || "#5E2BD6"});
  box-shadow:
    inset 0 2px 6px rgba(255, 255, 255, 0.2),
    inset 0 -3px 8px rgba(0, 0, 0, 0.35),
    0 8px 18px ${(p) => p.$shadow || "rgba(122, 60, 255, 0.35)"},
    0 2px 6px rgba(0, 0, 0, 0.25);
  position: relative;
  transition: transform 120ms ease, box-shadow 120ms ease, filter 120ms ease, opacity 120ms ease;

  &:before {
    content: "";
    position: absolute;
    left: 10px;
    right: 10px;
    top: 5px;
    height: 50%;
    border-radius: 9999px;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0.35), rgba(255, 255, 255, 0));
    pointer-events: none;
  }

  &:hover {
    transform: translateY(-1px);
    box-shadow:
      inset 0 2px 6px rgba(255, 255, 255, 0.22),
      inset 0 -3px 8px rgba(0, 0, 0, 0.35),
      0 10px 20px ${(p) => p.$shadow || "rgba(122, 60, 255, 0.4)"},
      0 3px 8px rgba(0, 0, 0, 0.25);
  }

  &:active {
    transform: translateY(0);
    box-shadow:
      inset 0 3px 10px rgba(0, 0, 0, 0.45),
      0 4px 10px ${(p) => p.$shadow || "rgba(122, 60, 255, 0.35)"};
    filter: brightness(0.98);
  }

  &:disabled {
    opacity: 0.6;
    filter: grayscale(0.2);
  }
`;

export const RoundPill = styled.button<{ $bgStart?: string; $bgEnd?: string; $shadow?: string; $disabled?: boolean }>`
  appearance: none;
  border: 0;
  outline: none;
  cursor: ${(p) => (p.$disabled ? "not-allowed" : "pointer")};
  user-select: none;
  width: clamp(64px, 12vw, 70px);
  height: clamp(64px, 12vw, 70px);
  border-radius: 50%;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  font-family: var(--font-family-poppins);
  color: #fff;
  background: linear-gradient(135deg, ${(p) => p.$bgStart || "#7A3CFF"}, ${(p) => p.$bgEnd || "#5E2BD6"});
  box-shadow:
    inset 0 2px 6px rgba(255, 255, 255, 0.2),
    inset 0 -3px 8px rgba(0, 0, 0, 0.35),
    0 8px 18px ${(p) => p.$shadow || "rgba(122, 60, 255, 0.35)"},
    0 2px 6px rgba(0, 0, 0, 0.25);
  position: relative;
  transition: transform 120ms ease, box-shadow 120ms ease, filter 120ms ease, opacity 120ms ease;

  & .power-value {
    font-weight: 800;
    font-size: clamp(14px, 3.5vw, 18px);
    line-height: 1;
  }
  & .power-label {
    font-weight: 600;
    font-size: clamp(10px, 2.8vw, 12px);
    line-height: 1;
    opacity: 0.9;
  }

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow:
      inset 0 2px 6px rgba(255, 255, 255, 0.22),
      inset 0 -3px 8px rgba(0, 0, 0, 0.35),
      0 10px 20px ${(p) => p.$shadow || "rgba(122, 60, 255, 0.4)"},
      0 3px 8px rgba(0, 0, 0, 0.25);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
    box-shadow:
      inset 0 3px 10px rgba(0, 0, 0, 0.45),
      0 4px 10px ${(p) => p.$shadow || "rgba(122, 60, 255, 0.35)"};
    filter: brightness(0.98);
  }

  &:disabled {
    opacity: 0.9;
    filter: grayscale(0.2);
    cursor: not-allowed;
    pointer-events: none;
  }
`;

// Empty State Components
export const EmptyStateContainer = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #0B011D 0%, #1a0a35 50%, #0d0520 100%);
  padding: 40px 20px;
  z-index: 10000;
`;

export const EmptyStateIcon = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(155, 77, 255, 0.15) 0%, rgba(106, 41, 221, 0.15) 100%);
  border: 3px solid rgba(155, 77, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 60px;
  margin-bottom: 32px;
  box-shadow: 
    0 0 30px rgba(155, 77, 255, 0.2),
    0 0 60px rgba(106, 41, 221, 0.1),
    inset 0 2px 10px rgba(255, 255, 255, 0.05);
  animation: float 3s ease-in-out infinite;
  
  @keyframes float {
    0%, 100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-10px);
    }
  }
  
  @media (max-width: 480px) {
    width: 100px;
    height: 100px;
    font-size: 50px;
    margin-bottom: 24px;
  }
`;

export const EmptyStateTitle = styled.h2`
  color: #ffffff;
  font-family: var(--font-family-poppins);
  font-size: clamp(24px, 5vw, 32px);
  font-weight: 700;
  margin: 0 0 16px 0;
  text-align: center;
  text-shadow: 0 2px 10px rgba(155, 77, 255, 0.3);
`;

export const EmptyStateSubtitle = styled.p`
  color: rgba(255, 255, 255, 0.65);
  font-family: var(--font-family-poppins);
  font-size: clamp(14px, 3.5vw, 16px);
  font-weight: 400;
  margin: 0;
  text-align: center;
  max-width: 400px;
  line-height: 1.6;
`;